module.exports = __webpack_public_path__ + "assets/img/25_371_big.9f6e9577.jpg";